import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEscrowTable extends Layout {
    sourceEscrowTransaction: DataSource;
    tableEscrow: Table;
}
